const defaultsScarcityBar = {
	scarcityBarText : '70% of offers have already been claimed!',
	scarcityBarBackgroundColor : {r: 255, g: 255, b: 255, a: 1},
	scarcityBarFillColor : {r: 52, g: 195, b: 143, a: 1},
	scarcityBarTextColor : {r: 255, g: 255, b: 255, a: 1},
	scarcityBarBorderColor : {r: 239, g: 239, b: 239, a: 0.5},
	scarcityBarPercent : 70,
	scarcityBarAreaBackgroundColor : {r: 255, g: 255, b: 255, a: 0},
}
export default defaultsScarcityBar